import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  color: ${(props) => props.theme.color.primary800};
  width: 55%;

  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    width: 100%;
  }

  & + & {
    @media (${(props) => props.theme.searchHero.mobileSwitch}) {
      margin-top: ${(props) => props.marginCols}px;
    }
  }
`;

export const IconBasic = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 25px;
  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    left: 12px;
  }
`;

export const inputwidth = 50;

export const Input = css`
  color: ${(props) => props.theme.color.primary800};
  font-family: ${(props) => props.theme.font.regular};
  border: none;
  height: ${inputwidth}px;
  padding: 0 15px 0 70px;
  box-sizing: border-box !important;
  width: 100%;

  @media (${(props) => props.theme.searchHero.mobileSwitch}) {
    padding-left: 45px;
    padding-right: 10px;
  }

  ::placeholder {
    color: ${(props) => props.theme.color.primary800};
  }

  &:focus {
    border: 2px solid ${(props) => props.theme.color.cta};
  }
`;
